import React from 'react';
import cx from 'classnames';

import styles from './styles.css';

const Headline = ({ headline, resultValue }) => {
  const headlineClass = cx({
    [styles.headline]: true,
    [styles.headlineWarn]: resultValue > 0.4 && resultValue < 0.7,
    [styles.headlineStop]: resultValue > 0.7,
  });

  return <h1 className={headlineClass}>{headline}</h1>;
};

export default Headline;



// WEBPACK FOOTER //
// ./src/components/ResultsContainer/Headline/index.js